import React, { useState } from "react";
import { WidthProvider, Responsive } from "react-grid-layout";
import ReactEcharts from "echarts-for-react";
import { getLineChart, getPieChart } from "./chart";
import SingleTable from "./SingleTable";
import SalesTrendsWidget from "../../components/SalesTrendsWidget.tsx";

const ResponsiveReactGridLayout = WidthProvider(Responsive) as any;

const DashboardPage: React.FC = () => {
  const [widgets] = useState([
    { i: "line", x: 0, y: 0, w: 8, h: 3, type: "line" },
    { i: "bar", x: 8, y: 0, w: 8, h: 3, type: "bar" },
    { i: "pie", x: 16, y: 0, w: 8, h: 3, type: "pie" },
    { i: "table", x: 0, y: 3, w: 12, h: 2, type: "table" },
  ]);

  const generateDOM = () =>
    widgets.map((widget) => {
      let component;
      switch (widget.type) {
        case "bar":
          component = <SalesTrendsWidget />;
          break;
        case "line":
          component = <ReactEcharts option={getLineChart()} style={{ width: "100%", height: "100%" }} />;
          break;
        case "pie":
          component = <ReactEcharts option={getPieChart()} style={{ width: "100%", height: "100%" }} />;
          break;
        case "table":
          component = <SingleTable />;
          break;
      }

      return (
        <div key={widget.i} data-grid={{ ...widget, minH: 2, minW: 4 }}>
          {component}
        </div>
      );
    });

  return (
    <div style={{ padding: 20, minHeight: "100vh", backgroundColor: "#fff" }}>
      <ResponsiveReactGridLayout cols={{ lg: 24, md: 24, sm: 24, xs: 24, xxs: 24 }} rowHeight={100}>
        {generateDOM()}
      </ResponsiveReactGridLayout>
    </div>
  );
};

export default DashboardPage;
